import * as CPR from '../services/clientPackages';
import { helpers } from '../utils';

export const ACTION_CLIENT_PACKAGES_LOADLIST = 'clientPackages/loadList';
export const ACTION_CLIENT_PACKAGES_LOAD_FULL_LIST = 'clientPackages/loadFullList';
export const ACTION_CLIENT_PACKAGES_LOAD_ITEM = 'clientPackages/loadItem';
export const ACTION_CLIENT_PACKAGES_CREATE = 'clientPackages/create';
export const ACTION_CLIENT_PACKAGES_UPDATE = 'clientPackages/update';
export const ACTION_CLIENT_PACKAGES_DELETE = 'clientPackages/remove';

export default {
  namespace: 'clientPackages',
  state: {
    clientPackagesFullList: [],
  },

  reducers: {
    updateStore(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },

  effects: {
    * loadList({ payload }, { call }) {
      try {
        return yield call(CPR.clientPackagesListRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    // whole list without pagination, used to fill the package selectors
    * loadFullList(_, { call, put }) {
      try {
        const response = yield call(CPR.clientPackagesListRequest, {});

        yield put({
          type: 'updateStore',
          payload: {
            clientPackagesFullList: response.data,
          },
        });

        return response;
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadItem({ payload }, { call }) {
      try {
        return yield call(CPR.clientPackagesItemRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * create({ payload: { data } }, { call }) {
      try {
        return yield call(CPR.clientPackagesCreateRequest, { ...data });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * update({ payload: { id, data } }, { call }) {
      try {
        return yield call(CPR.clientPackagesUpdateRequest, { id }, { ...data });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * remove({ payload: { id } }, { call, put }) {
      try {
        yield call(CPR.clientPackagesDeleteRequest, { id });

        yield put({
          type: 'app/addNotification',
          payload: {
            type: 'success',
            message: 'Common.Success',
            description: 'Component.Administration.ClientPackages.Remove.Success.Text',
          },
        });

        return true;
      } catch (e) {
        helpers.processException(e);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/clientPackages.js